/* eslint-disable no-unused-vars */
import { TRoleAccess } from '../constant/storage';
import { IGeneralComment } from './components/comment.interface';
import { FolderStatusEnum } from './training.interface';

// comment
export interface IPostEachCommentResponse extends IGeneralComment {
  postId: string;
  isAuthorPost: boolean;
}

export interface IPostCommentListResponse {
  data: IPostEachCommentResponse[];
  currentPage: number;
  totalPages: number;
  totalCount: number;
  pageSize: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  userRole: TRoleAccess;
}

export interface IPostCommentPayload {
  postId: string;
  content: string;
  parentId?: string;
}

export interface IPostUpdateCommentPayload {
  commentId: string;
  postId: string;
  content: string;
}

export interface IPostCommentSelectReturn {
  data: IPostEachCommentResponse[];
  meta: {
    totalCount: number;
    hasNextPage: boolean;
    pageSize: number;
    currentPage: number;
  };
  userRole: TRoleAccess;
}

// post

export enum EPostType {
  Post = 'Post',
  Blog = 'Blog',
}

export interface IPost {
  group?: {
    name: string;
    avatar: string;
    groupId: string;
    status: FolderStatusEnum;
    userRole: TRoleAccess;
    slug: string;
  };
  owner: {
    avatar: string | null;
    name: string;
    academicRank: string | null;
    userId: string;
    slug: string;
    hasBlueTick: boolean | null;
  };
  createdAt: string;
  isOwner: boolean;
  hashTags: { id: string; name: string }[];
  title: string;
  content: string;
  postId: string;
  react: number;
  isReact: boolean;
  images: string[];
  sharesCount: number;
  type: EPostType;
  commentCount: number;
  isRecruitExpired: boolean;
  isRecruitStarted: boolean;
  lastSubmittedAt: null | string;
  startDate: string | null;
  endDate: string | null;
  allowUploadedFile: boolean;
  readingTime?: number;
}

export interface IPostBE {
  id: string;
  title: string;
  content: string;
  type: string;
  shareCount: number;
  userId: string;
  owner: {
    slug: string | null;
    ownerId: number;
    avatar: string | null;
    fullName: string;
    academicRank: string | null;
    hasBlueTick: boolean;
  };
  postImages: Array<{ url: string; key: string }>;
  hashtags: Array<{
    id: string;
    name: string;
    userId: string;
    isDefault: boolean;
  }>;
  commentCount: number;
  createdOn: string;
  lastModifiedOn: string;
  isAuthorPost: boolean;
  votes: number;
  postVoted: {
    type: string;
    isVoted: boolean;
  };
  folder?: {
    id: string;
    name: string;
    status: string;
    avatar: string;
    cover: string;
    description: string;
    parentId: string;
    userRole: string;
  };
  isRecruitExpired: boolean;
  isRecruitStarted: boolean;
  lastSubmittedAt: null | string;
  startDate: string | null;
  endDate: string | null;
  allowUploadedFile: boolean;
}

export interface INewPostDetailBE {
  id: string;
  author: {
    academicRank: string;
    avatar: string;
    fullName: string;
    id: string;
    isVerified: boolean;
    slug: string;
  };
  canUploadFiles: boolean;
  content: string;
  createdOn: string;
  endOn: string;
  group?: {
    avatar: string;
    description: string;
    id: string;
    name: string;
    slug: string;
    status: string;
    userRole: string;
  };
  hasEnded: boolean;
  hashTags: {
    id: string;
    name: string;
  }[];
  hasStarted: boolean;
  images: string[];
  isAuthor: boolean;
  isVoted: boolean;
  lastModifiedOn: string;
  lastSubmittedAt: string;
  readingTime: number;
  startOn: string;
  title: string;
  totalComment: number;
  totalShare: number;
  totalVote: number;
  type: string;
}

export type TPostInfinityQuery = {
  data: IPost[];
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  pageSize: number;
  currentPage: number;
  totalPages: number;
  totalCount: number;
};

export type TPostQuery = IPost[];

export enum EPostVoteType {
  Love = 'Love',
}
